var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroller",on:{"click":function($event){return _vm.ScrollTo()}}},[_c('img',{staticClass:"scroller__image",attrs:{"src":require("@/assets/Images/Global/ArrowG.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }